import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisputeListComponent } from './dispute-list/dispute-list.component';
import { DisputeModalComponent } from './dispute-modal/dispute-modal.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    DisputeListComponent,
    DisputeModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule
  ],
  exports: [
    DisputeModalComponent,
    DisputeListComponent
  ]
})
export class DisputeTrackerModule { }
